import { IStoreReady } from '@/store/lib/storeSupport';
import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import { PaginationRequestType } from "@/entity/common/pagination.types";
import { IStaffSchedule, IStaffScheduleListItem } from "@/entity/staff/schedule.types";
import { StaffScheduleAddRequestType } from "@/form/staff/schedule/add.types";
import { StaffScheduleUpdateRequestType } from "@/form/staff/schedule/update.types";
import { ResponseDataType } from "@/form/form.types";

@Module({
    namespaced: true,
    name: 'staffSchedule',
    store,
    dynamic: true,
})
class StaffScheduleModule extends VuexModule implements IStoreReady{
    response: IStaffSchedule | null = null
    items: IStaffScheduleListItem[] = []
    default_from: string | null = null
    default_to: string | null = null
    item: IStaffScheduleListItem | null = null
    itemLoaded = false
    itemsLoaded = false
    ready = false

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ items: IStaffScheduleListItem[]; itemsLoaded: boolean; default_from: string | null; default_to: string | null }> {
        let itemsLoaded = false;
        const response = await store.$repository.staffSchedule.fetchAll(data);

        const items = response.data;
        if (items) {
            itemsLoaded = true;
        }

        const default_from = response.default_from;
        const default_to = response.default_to;

        return { items, itemsLoaded, default_from, default_to};
    }
    @Action({rawError: false})
    async create(data: StaffScheduleAddRequestType): Promise<ResponseDataType> {
        return await store.$repository.staffSchedule.create(data);
    }
    @Action({rawError: false})
    async update(data: StaffScheduleUpdateRequestType): Promise<ResponseDataType> {
        return await store.$repository.staffSchedule.update(data);
    }

    @Action({rawError: false})
    async delete(id: number): Promise<ResponseDataType> {
        return await store.$repository.staffSchedule.delete({id: id});
    }

    @Mutation
    setReady(st:boolean){
        this.ready = st
    }

}

export const StaffScheduleStore = getModule(StaffScheduleModule);
